import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleTableItemSelectorStyles = makeStyles((theme: Theme) =>
    createStyles({
        field: {
            [theme.breakpoints.down('sm')]: {
                '& input': {
                    height: 36,
                    fontSize: 14,
                    lineHeight: 1,
                    padding: '0px 19px 0px'
                }
            }
        }
    })
);
